import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled, { css } from 'styled-components';
import { arrayMoveImmutable } from 'array-move';
import ChooseExerciseModal from '../../molecule/Modals/ChooseExerciseModal';
import ExerciseViewDetail from '../../molecule/Modals/ExerciseViewDetail';
import { Exercise, ExerciseForm } from '../../../core/model';
import { getResources } from '../../../modules/Resource';
import { toast } from 'react-toastify';
import { secToHHMMSS, formatDataToModel, calculateSetDuration } from '../../../utils';
import { LIMITS } from '../../../core/constants';

// Components
import TextSortable from '../SortableElements/PlainText';
import ToggleSortable from '../SortableElements/ToggleType';
import ButtonSortable from '../SortableElements/ButtonPrompt';
import GenericSortable from '../SortableElements/Generic';
import SortableContainer from './SortableContainer';
import SelectSortable from '../SortableElements/SelectType';
import FloatingSelect from '../FloatingSelect';
import FloatingButton from '../FloatingSelect/Presets/ButtonWrapper';

const Container = styled.div`
  display: flex;
  flex-direction: row;
`
const FloatingSelectStyled = styled(FloatingSelect)`
  width: 100%;
`

const SortableContainerStyled = styled(SortableContainer)`
  margin: 0;
  width: 100%;
`

const ButtonSortableStyled = styled(ButtonSortable)`
  width: 100%;
  min-height: 70px;
`
const TextSortableStyled = styled(TextSortable)`
  width: 100%;
  min-height: 70px;
  margin-top: ${props => props.gap === 'true' ? '18px' : '0' };
`

const ToggleSortableStyled = styled(ToggleSortable)`
  width: 100%;
  min-height: 70px;
`

const SelectSortableStyled = styled(SelectSortable)`
  width: 100%;
  min-height: 70px;
  margin-top: ${props => props.gap === 'true' ? '18px' : '0' };
`

const SortableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

const GenericSortableStyled = styled(GenericSortable)`
  width: 100%;
  min-height: 55px;
`
const GenericContent = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 0;
  margin-left: auto;
  color: #666;
`
const TextStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  background: #eee;
  border: 1px solid #ccc;
  padding: 5px;
  border-radius: 10px;
  margin-left: 12px;
  color: #333;
`

const GroupWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 50px 20px 20px;
  background: #eee;
  border: 1px solid #ccc;
  margin-bottom: 20px;
  border-radius: 10px;
  // align-items: center;
  ${props => {
    if (props.disabled) {
        return css`
          opacity: 0.5;
        `
    }
  }}
`

const Header = styled.div`
  font-size: 22px;
  position: absolute;
  margin-top: -40px;
  font-weight: 700;
  justify-content: center;
  text-align: center;
  align-items: center;
  opacity: 0.8;
`

const DurationIndicator = ({
  data,
  resourceState,
  ...other
}) => {

  const duration = secToHHMMSS(calculateSetDuration(data,resourceState.resourceData.time_per_rep));
  return (
    <GenericSortableStyled
      hideButton
      index={0}
      removeHandle={true}
      onClick={() => {}}
      {...other}
    >
      <GenericContent>
        Duration:
        <TextStyled>
          {duration}
        </TextStyled>
      </GenericContent>
    </GenericSortableStyled>
  )
}

const DurationIndicatorStyled = styled(DurationIndicator)`
  position: fixed;
  width: auto;
`

const DurationWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  height: 75px;
  width: 100%;
`

class SortableTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      editModalOpen: false,
      editMode: false,
      modalType: null,
      editIndex: null,
      sectionIndex: null,
      enableWarmUp: false,
      enableCoolDown: false,
      WarmUpSection: [],
      WorkSection: [],
      CoolDownSection: [],
    }
  }

  async componentDidMount() {
    const { value, getResources, resourceState } = this.props;
    try {
      this.splitSections(value);
      
      if(!resourceState.resourceData) {
        await getResources();
      }
    } catch(e) {
      console.log('component: ',this,e.message);
      toast.error(e.message);
    }
  }

  splitSections = (value) => {
    let WarmUpSection = [], WorkSection = [], CoolDownSection = [];
    let hitWarmUp = false, hitWork = false, hitCoolDown = false;
    let enableWarmUp = false, enableCoolDown = false;

    for(let i = 0; i < value.length; i++) {
      const item = value[i];

      switch(item.type) {
        case 'warmup':
          hitWarmUp = true;
          break;
        case 'set':
          hitWork = true;
          break;
        case 'cooldown':
          hitCoolDown = true;
          break;
        default:
          break;
      }

      if(hitCoolDown){
        enableCoolDown = true;
        CoolDownSection.push(item);
      } else if(hitWork) {
        WorkSection.push(item);
      } else if(hitWarmUp) {
        enableWarmUp = true;
        WarmUpSection.push(item);
      }
    }

    if(WarmUpSection.length === 0){
      WarmUpSection.push({ type: 'warmup', value: 1 });
    }

    if(WorkSection.length === 0){
      WorkSection.push({ type: 'set', value: 1 });
    }

    if(CoolDownSection.length === 0){
      CoolDownSection.push({ type: 'cooldown', value: 1 });
    }

    this.setState({
      enableWarmUp,
      enableCoolDown,
      WarmUpSection,
      WorkSection,
      CoolDownSection
    });
  }

  onSortEnd = ({oldIndex, newIndex}, section) => {
    const { onChange } = this.props;
    const value = this.getSection(section);
    const modSort = arrayMoveImmutable(value, oldIndex, newIndex);
    const newItems = this.stitchSection(modSort, section);
    onChange(newItems);
  };

  removeElement = (index, section) => {
    const { onChange } = this.props;
    const value = this.getSection(section);
    const modItems = [...value];
    modItems.splice(index,1);
    const newItems = this.stitchSection(modItems,section);
    onChange(newItems);
  };

  updateValue = (index, section, event) => {
    const { onChange } = this.props;
    const value = this.getSection(section);
    const modItems = [...value];
    const val = event.target.value;
    modItems[index].value = parseInt(val);
    const newItems = this.stitchSection(modItems,section);
    onChange(newItems);
  }

  updateSetName = (index, section, event) => {
    const { onChange } = this.props;
    const value = this.getSection(section);
    const modItems = [...value];
    const val = event.target.value;
    modItems[index].name = val;
    const newItems = this.stitchSection(modItems, section);
    onChange(newItems);
  }

  openModal = (type = null, index = null, section = null) => this.setState({ modalOpen: true, modalType: type, editIndex: index, sectionIndex: section });

  closeModal = () => this.setState({ modalOpen: false, modalType: null });
  
  openEditModal = (index = null, section = null) => this.setState({ editModalOpen: true, editIndex: index, sectionIndex: section });

  closeEditModal = () => this.setState({ editModalOpen: false, editMode: false });

  toggleEditMode = (edit) => this.setState({ editMode: edit });

  handleSubmit = (exercise, edit = false) => {
    const { modalType, editIndex, sectionIndex } = this.state;
    if(editIndex != null) {
      this.updateElement(editIndex, exercise, sectionIndex);
    } else {
      this.addElement(modalType, exercise, sectionIndex);
    }
    this.closeModal();
    if(edit) {
      this.openEditModal(editIndex);
      this.toggleEditMode(true);
    }
  };

  handleExerciseUpdate = exercise => {
    const { editIndex, sectionIndex } = this.state;
    if(editIndex != null) {
      this.updateExercise(exercise, sectionIndex);
    }
    this.toggleEditMode(false);
  }

  // chooseExercise = type => {
  //   const { isTemplate } = this.props;
  //   if(isTemplate) {
  //     this.addElement(type);
  //   } else {
  //     this.openModal(type);
  //   }
  // }

  editExercise = (type, index, section) => {
    const { isTemplate } = this.props;
    if(!isTemplate) {
      this.openModal(type, index, section);
    }
  }

  viewExercise = (index, section) => {
    const { isTemplate } = this.props;
    if(!isTemplate) {
      this.openEditModal(index, section);
    }
  }

  updateElement = (index, exercise = null, section) => {
    const { onChange } = this.props;
    const value = this.getSection(section);
    const modItems = [...value];
    modItems[index].exercise = exercise;
    const newItems = this.stitchSection(modItems, section);
    onChange(newItems);
  }

  updateExercise = (exercise = null, section) => {
    if(exercise == null) {
      return;
    }

    const { onChange } = this.props;
    const value = this.getSection(section);
    const modItems = value.map(item => {
      if(item.exercise && item.exercise.id === exercise.id) {
        item.exercise = exercise;
        return item;
      } else {
        return item;
      }
    });
    const newItems = this.stitchSection(modItems, section);
    onChange(newItems);
  }

  addElement = (type, exercise = null, section) => {
    const { onChange } = this.props;
    const value = this.getSection(section);
    const modItems = [...value];
    switch(type) {
      case 'set':
        modItems.push({ type: 'set', value: 1 });
        break;
      case 'timed':
        modItems.push({ type: 'timed', value: 30, exercise: exercise });
        modItems.push({ type: 'rest', value: 5 });
        break;
      case 'rest':
        modItems.push({ type: 'rest', value: 5 });
        break;
      case 'reps':
        modItems.push({ type: 'reps', value: 10, exercise: exercise });
        break;
      default:
        break;
    }
    const newItems = this.stitchSection(modItems, section);
    onChange(newItems);
  }

  validateItem = data => {
    const modelObj = formatDataToModel(data, Exercise);
    const formObj = new ExerciseForm();

    if(modelObj){
      formObj.formatForForm(modelObj);
    }

    formObj.checkValidity();
    return formObj.primaryStatus !== 'Valid'
  }

  getSortable = (item, index, section) => {
    const { isTemplate, validate } = this.props;

    const timedItem = isTemplate
      ? <TextSortableStyled
          key={`item-${index}`}
          index={index}
          value={item.value}
          onChange={e => this.updateValue(index, section, e)}
          text="Timed Exercise"
          onClick={() => this.removeElement(index, section)}
          icon="access_alarm"
          type='timed'
        />
      : <ButtonSortableStyled
          key={`item-${index}`}
          index={index}
          value={item.value || 30}
          onPrompt={item.exercise ? () => this.viewExercise(index, section) : () => this.editExercise('timed', index, section)}
          onChange={e => this.updateValue(index, section, e)}
          text={item.exercise ? item.exercise.name : "Exercise"}
          type='timed'
          invalid={validate ? this.validateItem(item.exercise) : false}
          onClick={() => this.removeElement(index, section)}
        />;

    const repsItem = isTemplate
      ? <TextSortableStyled
          key={`item-${index}`}
          index={index}
          value={item.value}
          onChange={e => this.updateValue(index, section, e)}
          text="Rep Exercise"
          onClick={() => this.removeElement(index, section)}
          icon="fitness_center"
        />
      : <ButtonSortableStyled
          key={`item-${index}`}
          index={index}
          value={item.value || 10}
          onPrompt={item.exercise ? () => this.viewExercise(index, section) : () => this.editExercise('reps', index, section)}
          onChange={e => this.updateValue(index, section, e)}
          text={item.exercise ? item.exercise.name : "Exercise"}
          invalid={validate ? this.validateItem(item.exercise) : false}
          onClick={() => this.removeElement(index, section)}
        />;

    switch(item.type) {
      case 'set':
        return <SelectSortableStyled
                gap={"true"}
                key={`item-${index}`}
                index={index}
                value={item.value}
                items={LIMITS.classes.sets}
                onChange={e => this.updateValue(index, section, e)}
                text="Sets"
                includeSetName={section === 1}
                setName={item.name || ""}
                onNameChange={e => this.updateSetName(index, section, e)}
                onClick={() => this.removeElement(index, section)}/>;
      case 'timed':
        return timedItem;
      case 'rest':
        return <TextSortableStyled
                key={`item-${index}`}
                index={index}
                value={item.value}
                onChange={e => this.updateValue(index, section, e)}
                text="Rest"
                type='timed'
                onClick={() => this.removeElement(index, section)}/>;
      case 'reps':
        return repsItem;
      case 'rep':
        return repsItem;
      default:
        return null;
    }
  }

  updateSortables = (section) => {
    const { onChange } = this.props;
    const { enableWarmUp, enableCoolDown } = this.state;
    
    if(section === 0) {
      this.setState({enableWarmUp: !enableWarmUp},() => {
        const newArry = [{ type: 'warmup', value: 1 }]
        const newItems = this.stitchSection(newArry, section);
        onChange(newItems);
      })
    } else {
      this.setState({enableCoolDown: !enableCoolDown},() => {
        const newArry = [{ type: 'cooldown', value: 1 }]
        const newItems = this.stitchSection(newArry, section);
        onChange(newItems);
      })
    }
  }
  

  getSortables = (num) => {
    const value = this.getSection(num);
    if(value.length < 1){
      return;
    }
    const components = [];
    for(let i = 1; i < value.length; i++) {
      components.push(this.getSortable(value[i], i, num))
    }
    return components;
  }

  getSection = (num) => {
    const { WarmUpSection, WorkSection, CoolDownSection } = this.state;
    switch(num) {
      case 0:
        return WarmUpSection;
      case 1:
        return WorkSection;
      case 2:
        return CoolDownSection;
      default:
        break;
    }
  }

  stitchSection = (arry, num) => {
    const { enableWarmUp, enableCoolDown, WarmUpSection, WorkSection, CoolDownSection } = this.state;
    let newArry = [];

    if(enableWarmUp){
      newArry = num === 0 ? [...newArry, ...arry] : [...newArry, ...WarmUpSection]
    }

    newArry = num === 1 ? [...newArry, ...arry] : [...newArry, ...WorkSection]
    
    if(enableCoolDown){
      newArry = num === 2 ? [...newArry, ...arry] : [...newArry, ...CoolDownSection]
    }

    switch(num) {
      case 0:
        this.setState({WarmUpSection: arry});
        break;
      case 1:
        this.setState({WorkSection: arry});
        break;
      case 2:
        this.setState({CoolDownSection: arry});
        break;
      default:
        break;
    }
    return newArry;
  }

  getInitialSortable = (num) => {
    const value = this.getSection(num);
    if(value.length === 0){
      return;
    }
    const index = 0;
    const item = value[index];
    return <SelectSortableStyled
            key={`item-${index}`}
            index={index}
            value={item.value}
            items={LIMITS.classes.sets}
            onChange={e => this.updateValue(index, num, e)}
            text="Sets"
            removeHandle={true}
            includeSetName
            setName={item.name || ""}
            onNameChange={e => this.updateSetName(index, num, e)}
          />
  }

  getToggleSortable = (enabled, num) => {
    const value = this.getSection(num);
    // const text = num === 0 ? 'Warm Up' : 'Cool Down';
    if(value.length === 0){
      return;
    }
    const index = 0;
    const item = value[index];
    return <ToggleSortableStyled
            key={`item-${index}`}
            index={index}
            value={item.value}
            items={LIMITS.classes.sets}
            enabled={enabled}
            onToggle={() => this.updateSortables(num)}
            onChange={e => this.updateValue(index, num, e)}
            onClick={e => this.updateValue(index, num, e)}
            text="Sets"
            removeHandle={true}
          />
  }

  getSelects = (index, hasSets = false) => (
    <FloatingSelectStyled>
      <FloatingButton text='Timed Exercise' buttonIcon='access_alarm' onClick={() => this.addElement('timed', undefined, index)}/>
      <FloatingButton text='Rep Exercise' buttonIcon='fitness_center' onClick={() => this.addElement('reps', undefined, index)}/>
      <FloatingButton text='Rest' buttonIcon='weekend' onClick={() => this.addElement('rest', undefined, index)}/>
      {
        hasSets &&
        <FloatingButton text='New Set' buttonIcon='create_new_folder' onClick={() => this.addElement('set', undefined, index)}/>
      }
    </FloatingSelectStyled>
  )

  getWarmUp = () => {
    const { enableWarmUp } = this.state;
    return(
      <React.Fragment>
        <SortableContainerStyled onSortEnd={this.onSortEnd} useDragHandle>
          {this.getToggleSortable(enableWarmUp, 0)}
        </SortableContainerStyled>
        {
          enableWarmUp &&
          <SortableContainerStyled onSortEnd={(obj) => this.onSortEnd(obj, 0)} useDragHandle>
            {this.getSortables(0)}
            {this.getSelects(0)}
          </SortableContainerStyled>
        }
      </React.Fragment>
    )
  }

  getWork = () => {
    return(
      <React.Fragment>
        <SortableContainerStyled onSortEnd={this.onSortEnd} useDragHandle>
          {this.getInitialSortable(1)}
        </SortableContainerStyled>
        <SortableContainerStyled onSortEnd={(obj) => this.onSortEnd(obj, 1)} useDragHandle>
          {this.getSortables(1)}
          {this.getSelects(1,true)}
        </SortableContainerStyled>
      </React.Fragment>
    )
  }

  getCoolDown = () => {
    const { enableCoolDown } = this.state;
    return(
      <React.Fragment>
        <SortableContainerStyled onSortEnd={this.onSortEnd} useDragHandle>
          {this.getToggleSortable(enableCoolDown, 2)}
        </SortableContainerStyled>
        {
          enableCoolDown &&
          <SortableContainerStyled onSortEnd={(obj) => this.onSortEnd(obj, 2)} useDragHandle>
            {this.getSortables(2)}
            {this.getSelects(2)}
          </SortableContainerStyled>
        }
      </React.Fragment>
    )
  }

  render() {
    const { isSubmitting, submitForm, onChange, resourceState, value, ...other } = this.props;
    const { modalOpen, editModalOpen, editMode, sectionIndex, editIndex, enableWarmUp, enableCoolDown, } = this.state;
    let currentExercise = null;

    if(sectionIndex  != null) {
      const value = this.getSection(sectionIndex);
      if(editIndex != null && value[editIndex]) {
        currentExercise = value[editIndex].exercise;
      }
    }

    return (
      <React.Fragment>
        <Container {...other}>
          <SortableWrapper>
            <SortableContainerStyled onSortEnd={this.onSortEnd} useDragHandle style={{zIndex: 1}}>
              <DurationWrapper>
                <DurationIndicatorStyled data={value} resourceState={resourceState}/>
              </DurationWrapper>
            </SortableContainerStyled>
            <GroupWrapper disabled={!enableWarmUp} style={{ background: "#f1baba", border: "1px solid #d26c6c", color: "#ca6262" }}>
              <Header>Warm Up</Header>
              {this.getWarmUp()}
            </GroupWrapper>
            <GroupWrapper style={{ color: "#6f6f6f" }}>
              <Header>Work Out</Header>
              {this.getWork()}
            </GroupWrapper>
            <GroupWrapper disabled={!enableCoolDown} style={{ background: "#bacaf1", border: "1px solid #4d72c3", color: "#6277ca" }}>
              <Header>Cool Down</Header>
              {this.getCoolDown()}
            </GroupWrapper>
          </SortableWrapper>
        </Container>
        <ChooseExerciseModal
          anchor='right'
          open={modalOpen}
          onBackdropClick={this.closeModal}
          onClose={this.closeModal}
          onSubmit={this.handleSubmit}
          cardButtonIcon='add'
        />
        {
          currentExercise &&
          <ExerciseViewDetail
            data={currentExercise}
            open={editModalOpen}
            onBackdropClick={this.closeEditModal}
            onClose={this.closeEditModal}
            edit={editMode}
            onSubmit={this.handleExerciseUpdate}
            onEdit={(toggle = true) => this.toggleEditMode(toggle)}
            allowEdit={false}
          />
        }
      </React.Fragment>
    );
  }
}

SortableTable.propTypes = {
  value: PropTypes.array,
  isTemplate: PropTypes.bool,
  validate: PropTypes.bool,
}

SortableTable.defaultProps = {
  value: [],
  isTemplate: false,
  validate: false,
}

function mapStateToProps(state) {
  return {
    resourceState: state.resourceState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getResources: getResources,
  }, dispatch)
}

export default connect(mapStateToProps,mapDispatchToProps)(SortableTable);
